import React from 'react';
import { useSelector} from 'react-redux';
import { useTranslation } from 'react-i18next';
  
const NotAbleToReceiveSetsErrorMessage = () => {
    
    const validatedData = useSelector(
        (state) => state.createReceiveSetsReducer.createReceiveSets
    );
    const barcodeDetails = useSelector(
        (state) => state.receiveSetsListDataReducer.barcodeDetails
    );
    const { t } = useTranslation();
    return (
        <>
            {validatedData.statusCode === '10734' ? (
                <div>
                    {' '}
                    {t('more.common.templateDetails.set')} {barcodeDetails?.setNumber}
                    {'.'}
                    {barcodeDetails?.batchNumber} {t('receiveSets.ReceiveSetsLoc.NotAbleToReceiveSetsErrorMessage.notAbleToSetsErrorMsg')}
                </div>
            ) : validatedData.statusCode === '10830' ? (
                <>
                    {t('more.common.templateDetails.set')} {barcodeDetails?.setNumber}
                    {'.'}
                    {barcodeDetails?.batchNumber} {t('receiveSets.ReceiveSetsLoc.NotAbleToReceiveSetsErrorMessage.notAbleToSetsErrorMsg1')}
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export default NotAbleToReceiveSetsErrorMessage;
